import React, {Component} from "react"
import PropTypes from "prop-types"

import {List, Pagination, SearchField} from "~/components"
import {getPagedResources} from "~/utils/ShelfEntities"

export default class PaginatedListWithSearch extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      data: {
        items: []
      },
      page: 0,
      query: ""
    }

    this.handlePageChange = this.handlePageChange.bind(this)
    this.handleQuery = this.handleQuery.bind(this)
    this.handleQuerySubmit = this.handleQuerySubmit.bind(this)
  }

  getData() {
    getPagedResources(this.props.apiPath, this.state.page, this.state.query)
      .then(data => this.setState({data: data, loading: false}))
      .catch(error => this.setState({loading: false, error: error}))
  }

  handlePageChange(page) {
    this.setState({page: page}, () => this.getData())
  }

  handleQuery(query) {
    this.setState({query: query})
  }

  handleQuerySubmit() {
    this.setState({page: 0})
    this.getData()
  }

  componentDidMount() {
    this.getData()
  }

  render() {
    return (
      <div className="sh-searchable-list">
        <SearchField
          onChange={this.handleQuery}
          onSubmit={this.handleQuerySubmit}
          placeholder="Suchbegriff eintippen…"
          value={this.state.query}
        />

        <div className="results">
          <List
            items={this.state.data.items}
            itemRenderer={this.props.itemRenderer}
            itemDisableActions={this.props.itemDisableActions}
          >
            {this.props.children}
          </List>
        </div>

        <Pagination
          currentPage={this.state.page}
          totalPages={this.state.data.total_pages}
          onPageChange={this.handlePageChange}
        />
      </div>
    )
  }
}

PaginatedListWithSearch.propTypes = {
  apiPath: PropTypes.string.isRequired,
  itemRenderer: PropTypes.func.isRequired,
  itemDisableActions: PropTypes.bool,
  children: PropTypes.node
}



// WEBPACK FOOTER //
// ./src/components/decorators/PaginatedListWithSearch.js